export default "__VITE_ASSET__TrA6eQOw__"